var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMemoryIcon = function SvgMemoryIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229 153",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "memory-icon_svg__a",
    width: 229,
    height: 153
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h229v153H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 75,
    x: 36,
    y: 24,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 75,
    x: 91,
    y: 24,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 75,
    x: 144,
    y: 24,
    rx: 5,
    ry: 5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.237 6.514C3.07 1.155 8.798-.006 14.405 0c55.396.068 110.792.038 166.188.036 11.964 0 23.928-.05 35.892.03 6.4.042 11.59 4.943 11.634 11.121.11 15.226.052 30.453.062 45.68.002 2.483-1.448 3.92-3.625 4.56-6.215 1.828-10.037 5.786-11.21 12.196-1.418 7.731 3.332 15.105 10.968 17.071 2.59.667 3.858 2.265 3.864 5.018.015 7.106-.006 14.212-.01 21.317-.004 7.831.05 15.663-.022 23.493-.06 6.526-5.204 11.585-11.646 11.597-5.874.011-11.747.006-17.62.004-3.7 0-4.95-1.275-4.967-5.092-.019-4.35.034-8.702-.043-13.05-.047-2.69-1.842-4.646-3.936-4.52-2.197.132-3.4 1.761-3.43 4.681-.046 4.422-.049 8.845-.125 13.267-.056 3.24-1.569 4.711-4.736 4.713q-10.44.006-20.883.001c-3.487-.002-4.873-1.396-4.9-4.972-.032-4.35-.01-8.7-.056-13.05-.028-2.77-1.586-4.662-3.755-4.682-2.215-.02-3.594 1.762-3.612 4.721-.029 4.495.006 8.991-.069 13.485-.049 2.9-1.71 4.493-4.523 4.496-7.033.007-14.066.005-21.1.002-3.513-.002-4.875-1.369-4.9-4.958-.033-4.423-.014-8.846-.067-13.268-.03-2.52-1.705-4.524-3.704-4.563-2.17-.042-3.67 1.881-3.674 4.706-.006 4.495.031 8.991-.037 13.485-.046 3.02-1.706 4.594-4.658 4.597q-10.441.006-20.882.001c-3.643 0-5.006-1.359-5.036-5.069-.036-4.35.021-8.703-.097-13.05-.03-1.092-.252-2.534-.963-3.16-.893-.788-2.447-1.365-3.593-1.197-1.748.256-2.81 1.636-2.802 3.607.02 4.713.032 9.426-.018 14.138-.035 3.232-1.569 4.728-4.71 4.73q-10.441.006-20.882.001c-3.497 0-4.918-1.4-4.947-4.928-.037-4.495.026-8.993-.106-13.485-.032-1.067-.364-2.52-1.1-3.074-.949-.712-2.518-1.104-3.686-.893-1.68.306-2.577 1.71-2.568 3.56.024 4.785.048 9.571-.014 14.356-.032 2.432-1.62 4.432-3.472 4.44-7.25.024-14.5.006-21.752-.04-.6-.004-1.35-.174-1.77-.554-2.052-1.859-6.874-6.128-7.307-6.323v-52.65c1.286-.618 2.512-1.473 3.868-1.812 7.167-1.795 12.24-9.105 11.08-16.659C13.852 66.95 7.942 61.311 0 59.898 0 42.348.046 6.876.237 6.514",
    mask: "url(#memory-icon_svg__a)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMemoryIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;